// extracted by mini-css-extract-plugin
export default {"title_box":"index_title_box_eRv3W","title":"index_title_PA6cW","more":"index_more_EV7Bv"};